import { DynamicDialogRef } from 'primeng/api';
import { Component } from "@angular/core";

@Component({
    selector: "app-can-deactivate",
    templateUrl: "./can-deactivate.component.html",
    styleUrls: ["./can-deactivate.component.css"]
})
export class CanDeactivateComponent {
    constructor(private dynamicDialogRef: DynamicDialogRef) { }

    accept() {
        this.dynamicDialogRef.close(true);
    }

    reject() {
        this.dynamicDialogRef.close(false);
    }
}
